import styled from 'styled-components'

export const FormActionsContainer = styled.div`
  height: 36px;
`
